import { render } from "./userDlg.vue?vue&type=template&id=60e801d7"
import script from "./userDlg.vue?vue&type=script&lang=js"
export * from "./userDlg.vue?vue&type=script&lang=js"

import "./userDlg.vue?vue&type=style&index=0&id=60e801d7&lang=scss"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__